import { render, staticRenderFns } from "./WyseBaseButton.vue?vue&type=template&id=7a9bd947&scoped=true&"
import script from "./WyseBaseButton.vue?vue&type=script&lang=js&"
export * from "./WyseBaseButton.vue?vue&type=script&lang=js&"
import style0 from "./WyseBaseButton.vue?vue&type=style&index=0&id=7a9bd947&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a9bd947",
  null
  
)

export default component.exports